import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { creditPaymentService, CreateCreditPaymentData } from '../../services/creditPayments/creditPaymentService'
import { showSuccessToast, showErrorToast } from '../../utils/errorHandler'

export const useCreditPayments = (params?: {
  customer_id?: string
  bill_id?: string
  from?: string
  to?: string
}) => {
  return useQuery({
    queryKey: ['credit-payments', params],
    queryFn: () => creditPaymentService.getPayments(params),
    enabled: !!(params?.customer_id || params?.bill_id),
  })
}

export const useCreateCreditPayment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateCreditPaymentData) => creditPaymentService.createPayment(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['bills'] })
      queryClient.invalidateQueries({ queryKey: ['bill', variables.bill_id] })
      queryClient.invalidateQueries({ queryKey: ['credit-payments'] })
      queryClient.invalidateQueries({ queryKey: ['account-summary'] })
      showSuccessToast('Payment recorded successfully!')
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export const useDeleteCreditPayment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => creditPaymentService.deletePayment(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bills'] })
      queryClient.invalidateQueries({ queryKey: ['credit-payments'] })
      queryClient.invalidateQueries({ queryKey: ['account-summary'] })
      showSuccessToast('Payment deleted successfully!')
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}
